import { Button } from '../Button';
import { Text } from '../Text';
import { FormProgressIndicator } from '../FormProgressIndicator';
import Image from 'next/image';

import checkIcon from '../../public/static/images/check.svg';
import { logEvent } from '../../lib/analytics';
import {
  AgentConfirmationStepFragment,
  ConfirmationStepCopyFragment,
} from './ConfirmationStep.generated';
import { RichText } from '../../lib/copyRendering';
import { useRouter } from 'next/navigation';
import { PlanType } from './BasicsStep';

interface ConfirmationStepProps {
  planType?: PlanType;
  agent: AgentConfirmationStepFragment | undefined;
  copy: ConfirmationStepCopyFragment;
}

export const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  planType,
  agent,
  copy,
}) => {
  const router = useRouter();

  const isGroupPlan = planType === 'group';
  const directQuoteRedirect =
    planType === 'individual'
      ? agent?.under65Redirect
      : planType === 'medicare'
      ? agent?.over65Redirect
      : planType === 'dental'
      ? agent?.dentalRedirect
      : undefined;

  return (
    <div className="p-6">
      <div className="justify-center mb-6">
        <FormProgressIndicator
          steps={[
            'Basics',
            planType === 'group' ? 'Company' : 'Applicants',
            'Quote',
          ]}
          currentStepIndex={2}
        />
      </div>
      <div className="space-y-6">
        <div className="md:text-center space-y-4 max-w-xl mx-auto">
          {isGroupPlan ? (
            <Text.H4>
              That&apos;s it! We&apos;re preparing your group quote.
            </Text.H4>
          ) : agent ? (
            <Text.H4>Hi, I&apos;m {agent.name}</Text.H4>
          ) : (
            <Text.H4>That&apos;s it!</Text.H4>
          )}

          {isGroupPlan ? (
            <div className="text-sm text-gray-800">
              <RichText
                content={copy.quoteConfirmationGroup?.items[0]?.content}
              />
            </div>
          ) : agent?.slug ? (
            <>
              {directQuoteRedirect ? (
                <div className="flex justify-center">
                  <Button
                    variant="CTA"
                    analytics={{
                      category: 'Quote',
                      name: 'Redirect to direct quote',
                      directQuoteRedirect,
                    }}
                    onClick={() => {
                      router.replace(`/agents/${agent.slug}`);
                      router.push(directQuoteRedirect);
                    }}
                  >
                    See all plans
                  </Button>
                </div>
              ) : null}
              <div className="text-sm text-gray-800">
                <RichText content={copy.quoteConfirmation?.items[0]?.content} />
              </div>
            </>
          ) : (
            <div className="text-sm text-gray-800">
              <RichText
                content={
                  copy.quoteConfirmationErrorLoadingAgent?.items[0]?.content
                }
              />
            </div>
          )}
          <div className="text-center">
            <Image src={checkIcon} alt="" className="mx-auto h-16" />
          </div>
        </div>
      </div>
    </div>
  );
};
